
import { configureStore } from '@reduxjs/toolkit'
import controlbuttonReducer from './reducers/controlbuttonreducer'
import mapreducer from './reducers/mapreducer'
import feturepropreducer from './reducers/featurepropreducer'
import dropdownmasterreducer from './reducers/dropdownmasterreducer'
import currentFolioReducer from './reducers/currentfolioreducer'
import authcontrolReducer from './reducers/authcontrolreducer'
import authreducer from './reducers/authreducer'

export const store = configureStore({
  reducer: {
    controlbutton: controlbuttonReducer,
    mapreducer:mapreducer,
    featureprop:feturepropreducer,
    ddmaster: dropdownmasterreducer,
    currentfolio:currentFolioReducer,
    authcontrol:authcontrolReducer,
    authreducer: authreducer
  },

  // middleware: (getDefaultMiddleware) => getDefaultMiddleware({
  //   serializableCheck: false,
  //   immutableCheck: false
  // }),
 })


// import { createStore, applyMiddleware } from "redux";
// import { composeWithDevTools } from "redux-devtools-extension";
// import thunk from "redux-thunk";
// import rootReducer from "./reducers";

// const middleware = [thunk];

// const store = createStore(
//   rootReducer,
//   composeWithDevTools(applyMiddleware(...middleware))
// );







